export default function ready() {
	return window._ready;
}